import { Route } from './route.constant';

export function routeFromRoot(...route: string[]): string[] {
  return [Route.Root, ...route];
}

export function relativeRoute(...route: string[]): string[] {
  return ['..', ...route];
}
